export default function formattedCredits(credit: number): string {
  return `${Math.floor(credit / 60)} min ${Math.round(credit % 60)} sec`
}
